<template>
    <div class="maincontent py-1 has-background-light" id="haut" style="margin-top: 10px;">
        <div class="content columns mx-0">
            <div class="page column is-8 is-offset-2">
                <div class="post">
                    <div v-if="loading" class="loading">
                        Loading...
                    </div>
                    <div v-if="error" class="notification is-light">
                        <b>{{ error | capitalize }}</b>
                        <img src="../assets/notfound.svg">
                    </div>
                    <div v-if="post" class="box content blogpost">
                        <nav class="level">
                            <!-- Left side -->
                            <div class="level-left">
                                <div class="level-item">
                                    <h1 v-cloak class="title is-3">{{ post.title | capitalize }}</h1>
                                </div>
                            </div>
                            <!-- Right side -->
                            <div class="level-right">
                                <span title="publié le" class="has-text-grey"><i class="fas fa-clock"></i>&nbsp;{{post.datepost | formatDate}}</span>
                            </div>
                        </nav>
                        <br>
                        <template v-if="post.illustration">
                            <figure class="image">
                                <img :src="post.illustration.path" alt="illustration">
                            </figure>
                        </template>
                        <p v-html="post.editor"></p>
                        <template v-if="post.edito">
                            <div class="has-text-centered py-3">
                                <h5 class="has-text-primary is-size-4 my-2">Edito</h5>
                                <p><a target="_blank" :href="getFile(post.edito)">Télécharger le fichier</a></p>
                            </div>
                        </template>
                        <template v-if="post.sommaire">
                            <div class="has-text-centered py-3">
                                <h5 class="has-text-primary is-size-4 my-2">Sommaire</h5>
                                <p><a target="_blank" :href="getFile(post.sommaire)">Télécharger le fichier</a></p>
                            </div>
                        </template>
                        <template v-if="post.free_chapter">
                            <div class="has-text-centered py-3">
                                <h5 class="has-text-primary is-size-4 my-2">Chapitre gratuit à télécharger!</h5>
                                <p><a target="_blank" :href="getFile(post.free_chapter)">Télécharger le fichier</a></p>
                            </div>
                        </template>
                        <div class="has-text-centered py-5">
                            <social-sharing class="csha" v-bind:url="curr_path+'/post/'+ post._id" hashtags="JournalParoissial" v-bind:title="post.title+' 👉 '" inline-template>
                                <div>
                                    <network network="facebook">
                                        <i class="fab fa-facebook fa-2x"></i>
                                    </network><span style="visibility: hidden;">|||</span>
                                    <network network="twitter">
                                        <i class="fab fa-twitter fa-2x"></i>
                                    </network><span style="visibility: hidden;">|||</span>
                                    <network network="whatsapp">
                                        <i class="fab fa-whatsapp fa-2x"></i>
                                    </network><span style="visibility: hidden;">|||</span>
                                    <network network="linkedin">
                                        <i class="fab fa-linkedin fa-2x"></i>
                                    </network>
                                </div>
                            </social-sharing>
                        </div>
                    </div>
                </div>
                <template v-if="post && (post.categorie == 'parution')">
                    <div class="has-text-centered  mb-6">
                        <router-link class="button is-warning is-medium is-rounded my-0" to="/parutions">Voir toutes les parutions</router-link>
                        <router-link class="mx-5 button is-link is-medium is-rounded my-0" to="/page/achat-et-abonnement">Acheter le Journal</router-link>
                    </div>
                    <p class="mt-6 is-hidden"><i>A noter : si certains chapitres vous intéressent, vous pouvez les commander en version numérique (en plus ou à la place de l'édition papier). Cliquez sur "Acheter" pour plus d'informations.</i></p>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
const axios = require('axios');
var SocialSharing = require('vue-social-sharing');

export default {
    data: function() {
        return {
            maintitle: 'Actualité | ',
            loading: true,
            post: null,
            error: null,
            curr_path: window.location.origin,
        }
    },
    components: {
        SocialSharing
    },
    name: 'Post',
    props: {
        msg: String
    },
    created() {
        this.fetchData()
    },
    updated() {
        this.maintitle = this.maintitle + this.post.title
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        getFile(fileuri) {
            var xx = this.$api_url_base
            return xx + '/' + fileuri
        },
        fetchData() {
            this.error = this.post = null
            this.loading = true
            var vm = this
            var fetchurl = this.$api_url_posts
            axios({
                    method: 'post',
                    url: fetchurl,
                    headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify({
                        filter: { _id: vm.$route.params.id },
                        //fields: {fieldA:1},
                        limit: 1,
                        sort: { datepost: -1 },
                        populate: 1, // resolve linked collection items
                        lang: 'fr' // return normalized language fields (fieldA_de => fieldA)
                    })
                }).then(function(response) {
                    vm.loading = false
                    if (response.data.entries.length > 0) {
                        vm.post = response.data.entries[0]
                        vm.error = null
                    } else {
                        vm.post = null
                        vm.error = 'page introuvable'
                    }
                })
                .catch(function() {
                    //console.log("Erreur ! Impossible d'accéder à l'API." + error)
                    vm.error = 'page introuvable'
                })
        },
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.blogpost {
    border-left: 0px solid #000;
    margin-top: 80px;
    margin-bottom: 80px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.page {
    min-height: 550px;
    margin-bottom: 40px;
    margin-top: 40px;
    padding-left: 35px;
    padding-right: 35px;
}

.post .image {
    max-width: 250px;
    padding-left: auto;
    padding-right: auto;
    margin-left: auto;
    margin-right: auto;
}
</style>